@if (form) {
  <form class="flex h-full flex-col justify-between" [formGroup]="form">
    <hlm-tabs tab="general">
      <hlm-tabs-list>
        <button hlmTabsTrigger="general">Général</button>
        <button hlmTabsTrigger="compagnonnage">Compagnonnage</button>
        <button hlmTabsTrigger="metier">Métier</button>
        <button hlmTabsTrigger="sciences-et-culture">Sciences et culture</button>
      </hlm-tabs-list>
      <div hlmTabsSeparator></div>
      <div class="mt-lg">
        <div hlmTabsContent="general">
          <app-detail-general [form]="detailFormService.general" />
        </div>
        <div class="pt-0" hlmTabsContent="compagnonnage">
          <app-detail-compagnonnage [form]="detailFormService.compagnonnage" />
        </div>
        <div class="pt-0" hlmTabsContent="metier">
          <app-detail-metier [form]="detailFormService.metier" />
        </div>
        <div class="pt-0" hlmTabsContent="sciences-et-culture">
          <app-detail-sciences-culture [form]="detailFormService.sciencesCulture" />
        </div>
      </div>
    </hlm-tabs>
  </form>
}
